import { Validation, ValidationErrorType, ValidationResult } from "./Validation";

/**
 * Beschreibt einen Mietgegenstand.
 */
export default interface MaterialItemJson {
    ID: number | null;

    /**
     * Name des Materials.
     */
    title: string;

    /**
     * Kategorie des Materials.
     */
    category: string;

    /**
     * Notizenfeld für die Verwaltung.
     */
    remarks: string;

    /**
     * Anzahl der verfügbaren Gegenstände. Kann null sein, wenn Verfügbarkeit nicht geprüft werden soll.
     */
    amount: number | null;
}

export function defaultMaterialItemJson(): MaterialItemJson {
    return {
        ID: null,
        title: "",
        category: "",
        remarks: "",
        amount: null,
    };
}

export function validateMaterialItemJson(json: MaterialItemJson): ValidationResult<MaterialItemJson> {
    return new Validation(json)
        .validateInteger("ID", 0, null, false)
        .validateNonEmptyString("title", 100)
        .validateNonEmptyString("category", 100)
        .validateString("remarks", 1000)
        .validateInteger("amount", 0, 10000, true)
        .finish();
}

export function validateMaterialItemJsonAdd(json: MaterialItemJson): ValidationResult<MaterialItemJson> {
    return new Validation(json)
        .validateEquals("ID", null)
        .validateNonEmptyString("title", 100)
        .validateNonEmptyString("category", 100)
        .validateString("remarks", 1000)
        .validateInteger("amount", 0, 10000, true)
        .finish();
}